export default __webpack_public_path__ + "static/media/limb_mobile_small.5c6507d0.svg";